import { Navigate } from "react-router-dom"
import { Auth } from "../services/Auth"

const PrivilegeRoutes = ({ component, privilege }: any) => {
    const isPrivilege = Auth.hasPrivilege(privilege)
    if (!isPrivilege) Auth.logout()
    return isPrivilege ? component : <Navigate to="/" replace />
}

export default PrivilegeRoutes;